import { render, staticRenderFns } from "./ProjectTaskTable.vue?vue&type=template&id=0f11c85b&scoped=true&"
import script from "./ProjectTaskTable.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTaskTable.vue?vue&type=style&index=0&id=0f11c85b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f11c85b",
  null
  
)

export default component.exports